import { initContract } from '@ts-rest/core';
import { authDiscountContract } from './discount.auth.contract';

const c = initContract();

export const discountContract = c.router(
  {
    auth: authDiscountContract,
  },
  {
    pathPrefix: '/order',
    strictStatusCodes: true,
  },
);

export * from './discount.auth.contract';
export * from './models';
